import React from 'react';
import { StyledArrowLeft } from './styled';

const SliderArrowLeft = () => (
  <div className="slick-arrow slick-next">
    <StyledArrowLeft />
  </div>
);
export default SliderArrowLeft;
